import { useTranslation } from 'react-i18next';

/** Number formatters in the UI language: `integer` (grouped) and `oneDecimal` (exactly one decimal place). */
export const useNumberFormat = () => {
    const { i18n } = useTranslation();
    const integer = new Intl.NumberFormat(i18n.language);
    const oneDecimal = new Intl.NumberFormat(i18n.language, { minimumFractionDigits: 1, maximumFractionDigits: 1 });

    return { integer: value => integer.format(value), oneDecimal: value => oneDecimal.format(value) };
};
